import type { BannerKind } from 'LuxKit/Banners/types'
import type { LabV2HeaderBanner } from 'lib/labV2/headerBanners'
import { headerBannerDismissalId } from 'lib/labV2/headerBanners'
import { mapLabHeaderBannerKind } from './NotificationBannerV3.utils'

export type LabV2HeaderBannerCta = {
  label: string
  path: string
  style: 'primary' | 'secondary' | 'tertiary'
}

export type LabV2HeaderBannerItem = {
  id: string
  kind: BannerKind
  description: LabV2HeaderBanner['description']
  isCustomAppearance: boolean
  backgroundCss?: string
  textColor: string
  ctaPrimaryTextColor: string
  iconImageId?: string
  cta?: LabV2HeaderBannerCta
  /** Set only when the phone button differs from the desktop button. */
  mobileCta?: LabV2HeaderBannerCta
}

function bannerCta(
  cta: { label: string, path: string, style: LabV2HeaderBannerCta['style'] },
): LabV2HeaderBannerCta {
  return {
    label: cta.label,
    path: cta.path,
    style: cta.style,
  }
}

function sameCta(left: LabV2HeaderBannerCta, right: LabV2HeaderBannerCta): boolean {
  return left.label === right.label && left.path === right.path && left.style === right.style
}

export function labV2HeaderBannerItem(banner: LabV2HeaderBanner): LabV2HeaderBannerItem {
  const desktopCta = banner.cta?.desktop ? bannerCta(banner.cta.desktop) : undefined
  const mobileSource = banner.cta?.mobile ?? banner.cta?.desktop
  const mobileCta = mobileSource ? bannerCta(mobileSource) : undefined

  return {
    id: headerBannerDismissalId(banner),
    kind: mapLabHeaderBannerKind(banner.kind),
    description: banner.description,
    isCustomAppearance: banner.isCustomAppearance,
    backgroundCss: banner.isCustomAppearance ? banner.background.value : undefined,
    textColor: banner.textColor,
    ctaPrimaryTextColor: banner.ctaPrimaryTextColor,
    iconImageId: banner.iconImageId,
    cta: desktopCta,
    mobileCta: mobileCta && (!desktopCta || !sameCta(mobileCta, desktopCta)) ? mobileCta : undefined,
  }
}
